module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop1-8ac66420a4e6a223b4d75bd72a234c7a.jpg";